export const ClientSearchFormKey = {
  companyNameFilter: "companyNameFilter",
  companyName: "companyName",
  clientCodeFilter: "clientCodeFilter",
  clientCode: "clientCode",
  cityFilter: "cityFilter",
  clientType: "clientType",
  city: "city",
  countryFilter: "countryFilter",
  country: "country",
  status: "status",
} as const;

export interface ClientSearchFormProps {
  companyName: string;
  companyNameFilter: string;
  clientCodeFilter: string;
  clientType: string;
  clientCode: string;
  country: string;
  cityFilter: string;
  city: string;
  status: string;
}

export const ClientSearchResultFormKey = {
  isSelected: "isSelected",
  companyName: "companyName",
  clientCode: "clientCode",
  city: "city",
  clientType: "clientType",
  addressCountry: "addressCountry",
  tableBody: "tableBody",
  tableRow: "tableRow",
  tableFooter: "tableFooter",
  tablePagination: "tablePagination",
  tablePaginationPageNo: "tablePaginationPageNo",
} as const;

export const ClientSearchSaveFilterFormKey = {
  filterName: "filterName",
} as const;

export interface FilterProps {
  fieldName: string;
  fieldValue: string | string[];
  operatorId?: string;
  savedSearchFilterDataType?: number;
}

export interface CreateFilterProps {
  fieldName: string;
  operatorIdKey: string;
}

export interface ClientResultRowValue {
  id: string;
  name?: string;
  addressCountryId?: string;
  addressCountryName?: string;
  companyName: string;
  clientCode: string;
  clientTypeId?: string;
  addressCountry?: string;
  city?: string;
  hierarchy?: any;
  edit?: any;
  [key: string]: any;
}

export interface HierarchyType {
  id: string;
  name: string;
  clientCode: string;
  parentClientProfileId?: string;
  level: number;
  countryName: string;
  city: string;
}
export interface ClientSearchResultHierarchyProps {
  open: boolean;
  onClose: () => void;
  hierarchyData?: HierarchyType[];
  clientName: string;
}

export type ViewType = "hierarchy" | "list";
